import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["icon", "content"];

  toggle(event) {
    event.preventDefault();

    // toggle the collapsed class on the element
    event.target.classList.toggle("collapsed");

    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle("in");
    }

    // icon target is currently only used in the collapsible element
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("expanded");
    }
  }
}
